export class ApplicationResidenceApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getResidences({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/residence`);
  }

  async createResidence({ applicationId, borrowerId, withLoanOptionId, ...body }) {
    return this.#http.post(`/application/${applicationId}/borrower/${borrowerId}/residence`, body, {
      params: { withLoanOptionId },
    });
  }

  async editResidence({ applicationId, residenceId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/residence/${residenceId}`, body, {
      params: { withLoanOptionId },
    });
  }

  async deleteResidence({ applicationId, residenceId, ...params }) {
    return this.#http.delete(`/application/${applicationId}/residence/${residenceId}`, { params });
  }
}
